<div class="w-100 bg-light top-partners">
  <div class="custom-container">
    <div
      class="w-100 d-flex flex-column align-items-center justify-content-start"
    >
      <img src="assets/logos/TrustpilotLogo.png" alt="TrustpilotLogo" />
      <p class="section-title" style="margin: 10px 0px 6px 0px !important">
        Our top rated partners
      </p>

      <div class="w-100 overflow-hidden">
        <div
          class="highway-slider bg-light top-partners-wrapper mt-4"
          style="width: 100%"
        >
          <div class="highway-barrier">
            <ul class="highway-lane">
              <li class="highway-car" *ngFor="let partner of topPartners">
                <div class="d-flex flex-column justify-content-center gap-2">
                  <img
                    [src]="partner.logo"
                    [alt]="partner.name"
                    class="w-150 h-60 object-fit-contain"
                  />
                  <div
                    class="d-flex flex-row align-items-center justify-content-center gap-size-5"
                  >
                    <img [src]="partner.stars" alt="stars" />
                    <p class="text-xs">{{ partner.reviews }}</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
